/* 
  This offsets the sidebar so the top aligns with the first article's image or article top, not the title of the section or article title
  To use:
  <script src="{{ 'main-blog.js' | asset_url }}"></script>
  <script>
    const elementToOffset = element selector;
    window.addEventListener('load', offsetSidebar(elementToOffset));
    window.addEventListener('resize', () => {
      offsetSidebar(elementToOffset);
    });
  </script>
*/
function offsetSidebar(element, offset = 14) {
  if (element === "undefined") {
    return;
  }
  const sidebarOffset = document.querySelector(element)?.getBoundingClientRect().height;
  let t;
  clearTimeout(t);
  t = setTimeout(() => {
    if (document.querySelector(".sidebar") && window.innerWidth >= 1024) {
      document.querySelector(".sidebar").style.marginTop = `${sidebarOffset + offset}px`;
    } else {
      document.querySelector(".sidebar").style.marginTop = 0;
    }
  }, 100);
}

/* When the threshold for related articles has been reached, the leftover items are hidden. This click shows them */
const relatedLoadMoreTrigger = document.querySelector("[data-related-articles-load-trigger]");
relatedLoadMoreTrigger?.addEventListener("click", function () {
  relatedLoadMoreTrigger.querySelector("[data-load-text]").classList.add("hidden");
  relatedLoadMoreTrigger.querySelector("[data-loader]").classList.remove("hidden");
  this.remove();
  document.querySelector("[data-related-articles-hidden]")?.classList.remove("hidden");
});
